import {
    ACTIVATING_EXTERNAL_SCRIPT_REQUEST, ACTIVATING_EXTERNAL_SCRIPT_SUCCEDDED, ACTIVATING_EXTERNAL_SCRIPT_FAILED,
    UPDATING_EXTERNAL_SCRIPT_REQUEST, UPDATING_EXTERNAL_SCRIPT_SUCCEDDED, UPDATING_EXTERNAL_SCRIPT_FAILED
  } from '../actionTypes.jsx';
  import { activatingIntegrationSuccedded, deactivatingIntegrationSuccedded } from '../integrations';
  
  import axios from 'axios';
  
  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  const EXTERNAL_SCRIPT_BASE_URL = `${apiUrl}/api/2.0/integrations/external-script`;
  
  export function activateAccount(configuration) {
    return function (dispatch) {
      dispatch(activatingAccount());
  
      return axios({
        method: 'POST',
        url: EXTERNAL_SCRIPT_BASE_URL,
        data: configuration
      })
        .then((response) => {
          dispatch(activatingAccountSuccedded(response.data));
          dispatch(activatingIntegrationSuccedded(response.data));
          return response.data;
        })
        .catch(error =>
          dispatch(activatingAccountFailed(error.errors))
        )
    }
  }
  
  function activatingAccount() {
    return {
      type: ACTIVATING_EXTERNAL_SCRIPT_REQUEST,
      payload: {}
    }
  }
  
  function activatingAccountSuccedded(json) {
    return {
      type: ACTIVATING_EXTERNAL_SCRIPT_SUCCEDDED,
      payload: json
    }
  }
  
  function activatingAccountFailed(error) {
    return {
      type: ACTIVATING_EXTERNAL_SCRIPT_FAILED,
      payload: error
    }
  }
  
  export function updateExternalScriptConfiguration(configuration) {
    return function (dispatch) {
      dispatch(updatingExternalScriptConfiguration());
  
      return axios({
        method: 'PUT',
        url: EXTERNAL_SCRIPT_BASE_URL,
        data: configuration
      })
        .then((response) => {
          dispatch(updatingExternalScriptConfigurationSuccedded(response.data));
          dispatch(activatingIntegrationSuccedded(response.data));
        })
        .catch(error =>
          dispatch(updatingExternalScriptConfigurationFailed(error.errors))
        )
    }
  }
  
  function updatingExternalScriptConfiguration() {
    return {
      type: UPDATING_EXTERNAL_SCRIPT_REQUEST,
      payload: {}
    }
  }
  
  function updatingExternalScriptConfigurationSuccedded(json) {
    return {
      type: UPDATING_EXTERNAL_SCRIPT_SUCCEDDED,
      payload: json
    }
  }
  
  function updatingExternalScriptConfigurationFailed(error) {
    return {
      type: UPDATING_EXTERNAL_SCRIPT_FAILED,
      payload: error
    }
  }
  